import { Time } from "./Time"

export class WaitlistEntry {

    dateTime: Date

    constructor(
        public id: string,
        public organisationId: string,
        public venueId: string,
        public firstName: string,
        public lastName: string,
        public emailAddress: string,
        public phoneNumber: string | null,
        public merchantNotes: string | null,
        public partySize: number,
        public date: Date,
        public time: string,
        public reasonId: string | null,
        public eventId: string | null,
        public requiresWheelchairAccess: boolean,
        public requiresDogFriendly: boolean,
        public requiresPramAccessible: boolean,
        public requiresHighchairFriendly: boolean,
        public dateCreated: Date,
        public dateUpdated: Date,
        public numberOfTimesPrompted: number = 0,
        public dateLastPrompted: Date | null = null,
    ) {
            this.dateTime = new Time(time, null, null).dateTimeOnDate(date)
    }

    get fullName(): string {
        return `${this.firstName} ${this.lastName}`
    }
}
